import React from 'react';
import Label from './fromLabel';
import Error from './fromError';

interface TeaxtareaProps {
    placeholder?: string;
    value: string;
    onChange: (e: any) => void;
    disabled?: boolean;
    label?: string;
    isLabelBold?: boolean;
    required?: boolean;
    info?:string;
    error?:string;
    className?: string;
    mainElementClassName?: string;
}

const Textarea: React.FC<TeaxtareaProps> = ({  placeholder, value, onChange , disabled = false,label,required, info,error, className = ``, mainElementClassName = ``, isLabelBold = false}) => {
    return (
        <div className={ `my-6 text-[0.938rem] ${className}` }>
            {label && <Label text={ label } required={ required } info={ info } isBold={ isLabelBold } />}
            <textarea
                disabled={disabled}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className={ `pl-4 py-2 mt-3 ${error ? 'border-red-500 border-2' : 'border-[#CECECE] border'} rounded-md focus:outline-none text-[0.938rem] mt-2 font-normal text-[#222222] placeholder:text-[#a1a1a1] w-[99%] ${mainElementClassName}` }
                style={{ minHeight: 92 }}
            ></textarea>
        {error && <Error message={error} />}
        </div>
        
    );
};

export default Textarea;